<template>
    <div class="lead-page-wrapper">
    <!-- Header Section -->
    <v-container fluid class="header-section text-xs-center pt-5">
      <h1 class="display-2 font-weight-bold mb-3 primary--text mt-5 pt-5">
        Souscription devis <span class="title-text-shadow">Tukki</span>
      </h1>
      <p class="subtitle">Souscrivez simplement votre assurance Tukki en quelques clics.</p>
    </v-container>

    <!-- Main Content Card -->
    <v-container class="margin-top">
      <div class="aywa-container">
    <div class="pro-form-card">
      <div class="pro-form-header">
        <div class="header-right">
          <v-icon class="primary-color-assuraf mr-2">&#xe7ee;</v-icon>
          <span class="badge">Echec Paiement !</span>
        </div>
      </div>

     
      <!-- Card Header -->
      <!--      <div class="card-header">
        <button @click="prevStep" class="back-btn" v-if="step > 1">
          <i class="fas fa-arrow-left"></i>
        </button>
        <h2 class="card-title">Souscription Moto</h2>
      </div>-->

      <!-- Stepper -->
      <!-- Step Content -->
      <div class="card-body">
        <p class="text-center">Votre demande n'a pas pu être finalisée,<br>
        Merci de revoir vos informations de paiement et refaire l'opération ou alors nous contacter pour assistance.</p>

      </div>

      <!-- Card Footer -->
      <div class="card-footer">
        <!-- Bouton pour passer à l'étape suivante -->
        <div class="actions step2-actions">
          <button
            @click="goToHome()"
            class="btn-primary-modern"
          >
            <span>Accueil</span>
          </button>
        </div>
      </div>
    </div>
  </div>
    </v-container>
  </div>
</template>

<style scoped>
.lead-page-wrapper {
  background: linear-gradient(180deg, #ffa50992 0%, #e0f7fa 30%, #ffffff 40%, #ffffff 100%);
  min-height: 100vh;
  margin-top: 3%;
  font-family: 'Roboto', sans-serif; /* Ensure clean font */
}

/* Header Text Color Override if Primary isn't dark enough */
.primary--text {
  color: #2b2b2b !important; /* Teal Darken 4 for header */
}
.margin-top {
  margin-top: 2%;
}
.title-text-shadow {
  color: #ffa409;
  text-shadow:
    0 0 2px #fff,
    0 0 1px #fff,
    0 0 1px #fff,
    0 0 1px #fff,
    0 0 1px #fff,
    0 0 1px #fff,
    0 0 1px #fff,
    0 1px 2px rgba(0, 0, 0, 0.3),
    0 3px 9px rgba(0, 0, 0, 0.1);
}

.subtitle {
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  color: #616161; /* Corresponds to grey--text text--darken-1 */
  font-size: 16px; /* Corresponds to subheading */
}

@media (max-width: 600px) {
  .header-section h1 {
    font-size: 28px !important;
    line-height: 1.2 !important;
    margin-top: 20px !important;
    padding-top: 20px !important;
  }
  .subtitle {
    font-size: 14px;
    padding: 0 15px;
  }
  .lead-page-wrapper {
    margin-top: 0;
  }
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  font-size: 12px;
}
.pro-form-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 24px rgba(13, 78, 120, 0.15);
  padding: 20px;
  max-width: 880px;
  width: 100%;
  margin: 0 auto;
}

.pro-form-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(13, 78, 120, 0.12);
  margin-bottom: 16px;
}

.header-left {
  display: flex;
  align-items: center;
}

.titles .title {
  margin: 0;
  font-size: 18px;
  color: #0d4e78;
  font-weight: 700;
  line-height: 1.2;
}

.titles .subtitle {
  margin: 2px 0 0;
  font-size: 13px;
  color: #515457;
}

.badge {
  font-size: 12px;
  color: #0d4e78;
  background: rgba(13, 78, 120, 0.08);
  border: 1px solid rgba(13, 78, 120, 0.14);
  padding: 6px 10px;
  border-radius: 999px;
  display: inline-flex; /* assure l’alignement vertical */
  align-items: center;
}

@media (max-width: 768px) {
  .badge {
    font-size: 11px; /* compacte le badge sur petits écrans */
    padding: 6px 8px;
  }
  .header-right {
    gap: 8px; /* réduit l’espace pour tenir à côté */
  }
}
.header-right {
  display: inline-flex; /* aligne badge et icône sur une ligne */
  align-items: center;
  gap: 10px; /* espace entre badge et X */
  white-space: nowrap; /* évite le retour à la ligne sur mobile */
}

.badge {
  font-size: 12px;
  color: red;
  background: rgba(13, 78, 120, 0.08);
  border: 1px solid rgba(13, 78, 120, 0.14);
  padding: 6px 10px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
}

@media (max-width: 768px) {
  .badge {
    font-size: 11px;
    padding: 6px 8px;
  }
  .header-right {
    gap: 8px; /* réduit l’espace pour tenir à côté */
  }
}
.fields {
  margin-bottom: 10px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.col-sm-12 {
  flex: 1 1 100%;
}
.col-sm-6 {
  flex: 1 1 calc(50% - 12px);
  min-width: 260px;
}
.col-sm-3 {
  flex: 1 1 calc(25% - 12px);
  min-width: 200px;
}
.col-sm-4 {
  flex: 1 1 calc(30% - 12px);
  min-width: 200px;
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.field-label {
  font-weight: 600;
  color: #0d4e78;
  font-size: 13px;
}

.field-input,
.field-select,
textarea.field-input {
  width: 100%;
  height: 45px;
  border: 1px solid rgba(13, 78, 120, 0.22);
  border-radius: 10px;
  padding: 10px 12px;
  outline: none;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;
  background: #fff;
  color: #1c2b36;
  font-size: 14px;
}

.field-input:focus,
.field-select:focus,
textarea.field-input:focus {
  border-color: #ffa409;
  box-shadow: 0 0 0 3px rgba(255, 164, 9, 0.18);
}

/* New Upload Styles */
.upload-box-wrapper {
  background: #f8fafc;
  border: 2px dashed rgba(13, 78, 120, 0.2);
  border-radius: 12px;
  padding: 15px;
  transition: all 0.3s ease;
}

.upload-box-wrapper:hover {
  border-color: #ffa409;
  background: #fff;
}

.upload-options {
  display: flex;
  gap: 10px;
}

.btn-upload-opt {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  color: #0d4e78;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-upload-opt i {
  font-size: 18px;
  color: #ffa409;
}

.btn-upload-opt.camera {
  display: none; /* Masqué par défaut sur desktop */
}

.btn-upload-opt:hover {
  border-color: #ffa409;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.upload-preview {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: #ecfdf5;
  border-radius: 8px;
  border: 1px solid #10b981;
}

.file {
  width: 500px;
  margin-bottom: 0px;
  margin-left: 0%;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
}

.file-name {
  font-size: 13px;
  color: #065f46;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
}

.btn-remove-file {
  background: none;
  border: none;
  color: #ef4444;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background 0.2s;
}

.btn-remove-file:hover {
  background: rgba(239, 68, 68, 0.1);
}

@media (max-width: 600px) {
  .upload-options {
    flex-direction: column;
    gap: 12px;
  }

  .btn-upload-opt {
    padding: 15px;
    font-size: 14px;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    border: 2px solid #e2e8f0;
  }

  .btn-upload-opt.camera {
    display: flex; /* Affiché uniquement sur mobile */
    background: #fff8ed;
    border-color: #ffa409;
  }

  .btn-upload-opt i {
    font-size: 20px;
  }
}

.success-alert {
  border-color: rgba(13, 78, 120, 0.22) !important;
}

.actions {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}

.required-asterisk {
  color: red;
}

.next-btn-active {
  /* background: #ffa409; */
  color: #ffa409;
  font-weight: 500;
  /* border-color: #ffa409; */
}

.step2-actions {
  justify-content: space-between;
}

.back-btn {
  /* background-color: #f5f5f5; */
  color: #333;
}
/* ============== Ancien css*/
.devis-details p {
  font-size: 1.3rem;
  color: #333;
}
.devis-details .price {
  font-size: 2rem;
}

.aywa-container {
  max-width: 1000px;
  margin: 2rem auto;
  font-family: 'Poppins', sans-serif;
  color: #333;
}

.card {
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.card-header {
  display: flex;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #f0f0f0;
}

.back-btn {
  margin-top: -2px !important;
  background: none;
  /*border: 1px solid #e0e0e0;*/

  cursor: pointer;
  color: #555;
  transition: all 0.3s ease;
}

/*.back-btn:hover {
  background-color: #f5f5f5;
  border-color: #ccc;
}*/

.card-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}

.stepper {
  display: flex;
  justify-content: space-between;
  padding: 1.5rem 2.5rem;
  position: relative;
}

.stepper-line {
  position: absolute;
  top: 33px;
  left: 3%;
  right: 3%;
  height: 2px;
  background-color: #e0e0e0;
  transform: translateY(-50%);
  z-index: 1;
  margin: 0 auto;
  width: 88%;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  z-index: 2;
  position: relative;
}

.step-circle {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #fff;
  border: 2px solid #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  color: #999;
  transition: all 0.4s ease;
  margin-bottom: 0.5rem;
}

.step-label {
  font-size: 1.2rem;
  color: #999;
}

@media (max-width: 768px) {
  .stepper {
    padding: 1rem 0.5rem;
  }
  .stepper-line {
    top: 29px;
    left: 5%;
    right: 5%;
    width: 80%;
  }
  .step-circle {
    width: 26px;
    height: 26px;
    font-size: 11px;
    margin-bottom: 0.2rem;
  }
  .step-label {
    font-size: 9px;
    max-width: 45px;
    line-height: 1.1;
    word-break: break-word;
  }
}

.step.is-active .step-circle {
  border-color: #ffa409;
  color: #ffa409;
}

.step.is-active .step-label {
  color: #ffa409;
  font-weight: 600;
}

.step.is-completed .step-circle {
  background-color: #ffa409;
  border-color: #ffa409;
  color: #fff;
}

.step.is-completed .step-label {
  color: #333;
}
.card-body {
  padding: 0rem 2.5rem;
}

.step-header {
  text-align: center;
  margin-bottom: 2rem;
}

.step-title-main {
  font-size: 1.8rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
}

.step-description {
  font-size: 1rem;
  color: #777;
}

.form-row {
  display: flex;
  gap: 1.5rem;
}

.form-row .form-group {
  flex: 1;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-size: 0.9rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #555;
}

.form-control-modern {
  padding: 0.8rem 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}

.form-control-modern:focus {
  outline: none;
  border-color: #ffa409;
  box-shadow: 0 0 0 2px rgba(0, 165, 165, 0.1);
}

.card-footer {
  display: flex;
  justify-content: flex-end;
  padding: 1.5rem;
  /*//background-color: #f9f9f9;*/
  border-top: 1px solid #fff;
  gap: 1rem;
}

.btn-primary-modern,
.btn-secondary-modern {
  padding: 0.8rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
}

.btn-primary-modern {
  background-color: #ffa409;
  color: #fff;
}

.btn-primary-modern:hover {
  background-color: #008a8a;
}

.btn-primary-modern:disabled {
  background-color: #d3d3d3;
  cursor: not-allowed;
}

.btn-secondary-modern {
  background-color: #e0e0e0;
  color: #333;
}

.btn-secondary-modern:hover {
  background-color: #d1d1d1;
}

/* Upload Section */
.upload-section {
  display: flex;
  gap: 1rem;
  justify-content: center;
}
.upload-box {
  border: 2px dashed #e0e0e0;
  border-radius: 10px;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  flex: 1;
}
.upload-box:hover {
  border-color: #ffa409;
  background-color: #f7fdfd;
}
.upload-label {
  color: #555;
  font-weight: 500;
}
.file-input {
  display: none;
}

/* Duration Options consolidated at the end of file */

/* Payment Options */
.payment-options {
  text-align: center;
}
.payment-buttons {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-top: 1rem;
}
.payment-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 1.5rem;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 150px;
  color: #0a0a0a;
}
.payment-btn:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
}
.payment-btn img {
  height: 40px;
}

/* Devis Summary */
.devis-summary,
.confirmation-summary {
  background-color: #f9f9f9;
  border-radius: 10px;
  padding: 1.5rem;
}
.insurer-logo {
  max-height: 40px;
  margin-bottom: 1rem;
}
.price {
  font-size: 1.2rem;
  font-weight: 600;
  margin-top: 1rem;
  color: #ffa409;
}

/* Loading Overlay */
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}
.loading-spinner {
  text-align: center;
  font-size: 1.2rem;
}
.loading-spinner i {
  font-size: 3rem;
  color: #ffa409;
  margin-bottom: 1rem;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.modal-content {
  background: #fff;
  padding: 2rem;
  border-radius: 15px;
  width: 90%;
  max-width: 450px;
}
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;
}
</style>

<script>

export default {
  name: 'aywapaymentFailed',
  props: {
    id_association: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      numerodevis: '',
      step: 1,
      selectedDuration: null,
      // Global state
      isLoading: false,
      loadingMessage: '',
      contratDetails: null, // Pour stocker les détails du contrat
      pollingIntervalId: null,
      pollingTimeoutId: null,
      ToastTabSucess: {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 4000,
        fitToScreen: true,
        type: 'success',
        className: 'custom-success-class'
      },
      ToastTabError: {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 4000,
        fitToScreen: true,
        type: 'error'
      }
    };
  },
  methods: {
    goToHome() {
      this.$router.push({ name: 'tukki_subscription' });
    },

    
  }, 
};
</script>

<style scoped>
/* Form & Button Styles */
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #495057;
  font-size: 15px;
}

.form-control-modern {
  display: block;
  width: 100%;
  padding: 12px 16px;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 8px;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

.form-control-modern:focus {
  color: #212529;
  background-color: #fff;
  border-color: #3d84f7;
  outline: 0;
  box-shadow: 0 0 0 4px rgba(61, 132, 247, 0.15);
}

.navigation-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}

.btn-primary-modern,
.btn-secondary-modern {
  padding: 12px 24px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.btn-primary-modern {
  background-color: #ffa409;
  color: #fff;
}

.btn-primary-modern:hover {
  background-color: #e89508;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.btn-secondary-modern {
  background-color: #f0f2f5;
  color: #495057;
}

.btn-secondary-modern:hover {
  background-color: #e2e6ea;
  transform: translateY(-2px);
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
}

.modal-content {
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
  text-align: left;
}

.modal-content h3 {
  text-align: center;
  margin-bottom: 20px;
}

.modal-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.modal-actions .btn-secondary {
  background-color: #6c757d;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  color: white;
}

.loading-spinner {
  text-align: center;
}

.loading-spinner .fa-spinner {
  font-size: 38px;
  margin-bottom: 15px;
}

.loading-spinner p {
  font-size: 16px;
}

.devis-summary {
  background-color: #f9f9f9;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 20px;
  margin-top: 20px;
  text-align: left;
}

.insurer-info {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.insurer-logo {
  width: 50px;
  height: 50px;
  margin-right: 15px;
}

.devis-details p {
  margin: 5px 0;
}

.price {
  margin-top: 15px;
  font-size: 1.2em;
  font-weight: bold;
}

.price span {
  color: #007bff;
}

.form-group {
  margin-bottom: 15px;
  text-align: left;
}

label {
  display: block;
  margin-bottom: 5px;
}

input[type='date'] {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border-radius: 5px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  margin-bottom: 10px;
}

input[type='tel'],
input[type='text'],
input[type='number'] {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border-radius: 5px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  margin-bottom: 10px;
}

/*button {
  padding: 12px 25px;
  font-size: 18px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;
}*/

button:disabled {
  /*//background-color: #ccc;*/
  cursor: not-allowed;
}

button .fa-spinner {
  margin-right: 8px;
}

.step-indicator {
  font-size: 14px;
  color: #666;
  margin-bottom: 15px;
}

.upload-section {
  margin: 20px 0;
}

.upload-box {
  border: 2px dashed #ccc;
  border-radius: 10px;
  padding: 30px;
  margin-bottom: 20px;
  cursor: pointer;
}

.upload-box:hover {
  border-color: #ffa409;
}

.upload-label {
  font-size: 18px;
  color: #333;
}

.file-input {
  display: none;
}

.error-message {
  color: #e53e3e;
  background-color: #fed7d7;
  border: 1px solid #fbb6b6;
  padding: 1rem;
  border-radius: 8px;
  margin-top: 1.5rem;
  text-align: center;
}

.duration-options {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin: 20px 0;
}

@media (max-width: 480px) {
  .duration-options {
    grid-template-columns: 1fr;
  }
}

.duration-btn {
  background-color: #f8fafc;
  color: #0d4e78;
  border: 2px solid #e2e8f0;
  padding: 15px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.duration-btn:hover {
  border-color: #ffa409;
  background-color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.duration-btn.selected {
  background-color: #fff8ed;
  color: #ffa409;
  border-color: #ffa409;
  box-shadow: 0 0 0 3px rgba(255, 164, 9, 0.1);
}

.duration-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.duration-label {
  font-size: 16px;
  font-weight: 600;
}

.duration-price {
  font-size: 14px;
  opacity: 0.8;
  font-weight: 500;
}

.duration-btn.selected .duration-price {
  color: #e89508;
}

.payment-options .payment-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  margin-top: 20px;
}

.payment-options .payment-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #ddd;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #fff;
  width: 180px;
}

.payment-options .payment-btn:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.payment-options .payment-btn img {
  height: 50px;
  margin-bottom: 15px;
  object-fit: contain;
}

.payment-options .payment-btn.wave {
  border-color: #41c3ff;
}

.payment-options .payment-btn.om {
  border-color: #ff7800;
}

.confirmation-summary {
  background-color: #f0f8ff;
  border: 1px solid #add8e6;
  border-radius: 8px;
  padding: 15px;
  margin: 20px 0;
  text-align: left;
  font-size: 13px;
}

.confirmation-summary ul {
  list-style: none;
  padding: 0;
}

.confirmation-summary li {
  margin-bottom: 8px;
}

.sharing-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.btn-refresh {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f0f2f5;
  border: 1px solid #e2e8f0;
  padding: 8px 16px;
  border-radius: 8px;
  color: #0d4e78;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-refresh:hover:not(:disabled) {
  background: #e2e8f0;
  border-color: #cbd5e1;
  transform: translateY(-1px);
}

.btn-refresh:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.sharing-options {
  text-align: center;
  margin-top: 2rem;
}

.share-buttons-container {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: 1rem;
}

.share-btn {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.8rem 1.2rem;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1.2rem;
  font-weight: 500;
  color: #fff;
}

.share-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.share-btn i {
  font-size: 1.2rem;
  width: auto;
  text-align: center;
}

.share-btn.pdf {
  background-color: #d9534f;
}
.share-btn.whatsapp {
  background-color: #25d366;
}
.share-btn.sms {
  background-color: #f0ad4e;
}
</style>

<style scoped>
/* OCR Details Styles */
.ocr-details-card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e9ecef;
  margin-bottom: 20px;
}

.details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
}

.detail-item {
  display: flex;
  flex-direction: column;
}

.detail-label {
  font-size: 11px;
  color: #6c757d;
  text-transform: uppercase;
  font-weight: 700;
  margin-bottom: 4px;
}

.detail-value {
  font-size: 14px;
  color: #0d4e78;
  font-weight: 600;
}

.btn-outline-primary {
  transition: all 0.3s;
  border: 1px solid #ffa409;
  background-color: transparent;
  color: #ffa409;
  padding: 0.8rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.btn-outline-primary:hover {
  background: #ffa409 !important;
  color: #fff !important;
}

.btn-outline-primary:disabled {
  border-color: #d3d3d3;
  color: #d3d3d3;
  cursor: not-allowed;
}

@media (max-width: 600px) {
  .card-footer {
    padding: 1rem;
  }

  .actions.step2-actions {
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }

  .actions.step2-actions .btn-primary-modern,
  .actions.step2-actions .btn-outline-primary,
  .actions.step2-actions .wizard-btn.back-btn,
  .card-footer > .btn-primary-modern {
    width: 100% !important;
    margin: 0 !important;
    justify-content: center;
    padding: 0.7rem 1rem;
    font-size: 1.2rem;
    height: auto;
    min-height: 44px;
  }

  .card-footer {
    flex-direction: column;
    gap: 10px;
  }

  /* Pour l'étape 2 spécifiquement, on veut le bouton Suivant en premier (en haut) */
  .actions.step2-actions {
    display: flex;
    flex-direction: column-reverse;
  }

  .actions.step2-actions .btn-primary-modern {
    order: -1;
    margin-bottom: 4px !important;
  }
}
</style>
